const selectConfig = (state) => state.config;
export {
  selectConfig
};
